import Vue from 'vue';
import {
    BootstrapVue,
    ModalPlugin,
    DropdownPlugin,
    IconsPlugin,
    FormDatepickerPlugin
} from 'bootstrap-vue';

Vue.use(BootstrapVue);
Vue.use(ModalPlugin);
Vue.use(DropdownPlugin);
Vue.use(IconsPlugin);
Vue.use(FormDatepickerPlugin);
